import { RemoteApiErrorMessage } from './remote-api-error-message.model';
import { RemoteApiErrorSeverity } from './remote-api-error-severity.enum';

export class RemoteApiError {
  public static fromJSON(json: any) {
    const messages: any[] = [];

    json.messages.forEach((element: any) => {
      messages.push(RemoteApiErrorMessage.fromJSON(element));
    });

    return new RemoteApiError(json.severity, messages);
  }

  constructor(
    public readonly severity: RemoteApiErrorSeverity,
    public readonly messages: RemoteApiErrorMessage[]
  ) {
    if (!severity) {
      severity = this.getMaxSeverity(messages);
    }
  }

  private getMaxSeverity(
    messages: RemoteApiErrorMessage[]
  ): RemoteApiErrorSeverity {
    const messageSeverities = messages ? messages.map((it) => it.severity) : [];
    // TODO: Change if default severity shouldn't be Error
    const defaultSeverity = RemoteApiErrorSeverity.Error;

    if (messageSeverities.find((it) => it === RemoteApiErrorSeverity.Debug)) {
      return RemoteApiErrorSeverity.Debug;
    }

    if (messageSeverities.find((it) => it === RemoteApiErrorSeverity.Error)) {
      return RemoteApiErrorSeverity.Error;
    }

    if (messageSeverities.find((it) => it === RemoteApiErrorSeverity.Warning)) {
      return RemoteApiErrorSeverity.Warning;
    }

    if (messageSeverities.find((it) => it === RemoteApiErrorSeverity.Info)) {
      return RemoteApiErrorSeverity.Info;
    }

    return defaultSeverity;
  }
}
